/** @license ISC License (c) copyright 2017 original and current authors */

/** @author Ian Hofmann-Hicks (evil) */
var isSameType = require('./isSameType');

var isSame = require('./isSame');

var hasAlg = require('./hasAlg');

var type = require('./type');

var fl = require('./flNames');

var comp = function comp(a, b) {
  return a.valueOf() === b.valueOf();
};

var strats = {
  'Array': function Array(a, b) {
    return a.length === b.length && deepEquals(a, b);
  },
  'Date': function Date(a, b) {
    return isSame(a.valueOf(), b.valueOf());
  },
  'Error': function Error(a, b) {
    return a.name === b.name && a.message === b.message;
  },
  'Object': function (_Object) {
    function Object(_x, _x2) {
      return _Object.apply(this, arguments);
    }

    Object.toString = function () {
      return _Object.toString();
    };

    return Object;
  }(function (a, b) {
    return Object.keys(a).length === Object.keys(b).length && deepEquals(a, b);
  }),
  'RegExp': function RegExp(a, b) {
    return a.source === b.source && a.ignoreCase === b.ignoreCase && a.global === b.global && a.multiline === b.multiline && a.unicode === b.unicode;
  }
};

function deepEquals(a, b) {
  for (var key in a) {
    if (!equals(a[key], b[key])) {
      return false;
    }
  }

  return true;
}

function equals(a, b) {
  if (isSame(a, b)) {
    return true;
  }

  if (!isSameType(a, b)) {
    return false;
  }

  if (hasAlg('equals', a)) {
    return (b[fl.equals] || b.equals).call(b, a);
  }

  return (strats[type(a)] || comp)(a, b);
}

module.exports = equals;